import { Injectable } from '@angular/core'
import { LemonaidKirjanpidonProjekti, Projekti } from '@lemon/core-firebase/model/kirjanpito-projektit'
import { LemonaidProjektitUriService } from '@lemon/core-firebase/service/projektit-uri.service'
import { Observable, of } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { PROJEKTI_VARIT, ProjektinVarit, ProjektitService } from '../../_jaettu-angular/projektit.service'
import { FirebaseLemonaid } from './firebase-lemonaid.service'
import { KayttajaService } from './kayttaja.service'

@Injectable()
export class ProjektiServiceLemonaidImpl implements ProjektitService {
  naytettavatKirjanpitoprojektitObservable: Observable<Projekti[]>
  naytaProjektitObservable: Observable<boolean>

  constructor(
    private _firebaseLemonaid: FirebaseLemonaid,
    private _lemonaidProjektitUriService: LemonaidProjektitUriService,
    private _kayttajaService: KayttajaService,
  ) {
    this.naytettavatKirjanpitoprojektitObservable = this._kayttajaService.nykyinenAsiakasObservable.pipe(
      switchMap(asiakas => {
        if (!asiakas) {
          return of<Projekti[]>([])
        }
        const uri = this._lemonaidProjektitUriService.annaKirjanpitoLemonaidProjektitCollection(asiakas.asiakasAvain)
        return this._firebaseLemonaid
          .firestoreCollection<LemonaidKirjanpidonProjekti>(uri)
          .listen()
          .pipe(map(projektit => projektit.filter(p => p && p.viewableInLemonaid && p.avain && p.nimi).map(p => ({ avain: p.avain, nimi: p.nimi }) as Projekti)))
      }),
    )

    this.naytaProjektitObservable = this.naytettavatKirjanpitoprojektitObservable.pipe(map(projektit => !!projektit?.length))
  }

  annaProjektinVarit(projektiAvain: string): ProjektinVarit {
    let sum = 0
    for (const char of projektiAvain) {
      sum += char.charCodeAt(0)
    }
    const index = sum % PROJEKTI_VARIT.length
    return PROJEKTI_VARIT[index]
  }
}
